let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("llyF2")).then(() => parcelRequire('7xsfX'));